import React from 'react';
import Webcam from "react-webcam";
import Popup from 'reactjs-popup';

  
function Scale() {


  return (
    <div className="App">
      <header className="App-header">


        <strong>
          Scale Simulator
          
        </strong>
        <br />

        {' '}
        If you are reading this, the chances are that you are closer to your computer than the nearest scale. 
        <br />
        <br />

        Please take a minute to ponder the magnitude of this inconvenience.
        <br />
        <br />
        To use this simulator, simply close your laptop and imagine it as a scale. Place it on a hard and flat surface that is capable of supporting your weight. Then, stand on top of it. After 1 minute, our advanced artificial machine learning intelligence predictive modeling will be able to accurately measure your weight.
        <br />
        <br />
        (However, the protocol for displaying the measured weight in a web-based format is still under development).
        <br />
        <br />
        <h1>0.000 lbs</h1>


</header>
</div>
  );
}

export default Scale;
